
const SvgPaymentFailLottie = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="120"
      height="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m11.607396 22.992952a11.000732 11.000733 0 0 0 1.099682-.015626 11.000732 11.000733 0 0 0 10.270216-11.684372 11.000732 11.000733 0 0 0 -11.684372-10.2702169 11.000732 11.000733 0 0 0 -10.270216 11.6843729 11.000732 11.000733 0 0 0 10.58469 10.285842z"
        fill="#da4453"
      />
      <path
        d="m12 19.000467c.554037 0 1.000067-.446029 1.000067-1.000066s-.44603-1.000067-1.000067-1.000067-1.000066.44603-1.000066 1.000067.446029 1.000066 1.000066 1.000066zm.0039-4.000266c.552308 0 .996166-.44374.996166-.996161v-7.0082796c0-.5522367-.443858-.9961604-.99616-.9961604h-.0078c-.552315 0-.996172.4439237-.996172.9961604v7.0082796c0 .552421.443857.996161.99616.996161h.0078z"
        fill="#fff"
      />
    </svg>
  );
};

export default SvgPaymentFailLottie;
